import { apiConnector } from "../apiConnection";
import {
  getUserProfileEndpoint,
  loginEndpoint,
  sendOtpEndpoint,
  signUpEndpoints,
  updateGenderPreferenceEndpoint,
  updatePasswordEndpoint,
  verifyOtpEndpoint,
} from "../apiEndpoints";
import toast from "react-hot-toast";

// export const loginApi = async (email,password) =>{
//     try {
//
//         const bodyData={
//             email,password
//         }
//         const request = {
//             url:loginEndpoint.url,
//             method:loginEndpoint.method,
//             bodyData,
//             withCredentials: true,
//         }
//
//         toast.loading("Logging you in");
//         const {data} = await apiConnector(request);
//         toast.dismiss()
//         toast.success("Logged in successfudilly")
//
//         return data;
//     } catch (error) {
//         toast.dismiss()
//         toast.error("Could not log you in")
//        console.error(error);
//     }
// }
export const loginApi = async (email, password) => {
  try {
    const bodyData = {
      email,
      password,
    };
    const request = {
      method: loginEndpoint.method,
      url: loginEndpoint.url,
      bodyData: bodyData,
      withCredentials: loginEndpoint.withCredentials,
    };
    toast.loading("Logging you in");
    const response = await apiConnector(request);

    toast.dismiss();
    if (response.status !== 200)
      throw new Error(response.data?.message || "error occured!");

    localStorage.removeItem("token");
    localStorage.setItem("token", `${response.data.token}`);
    localStorage.setItem("user", `${response.data.name}`);
    toast.success("User logged in");
    window.location.href = "/";
    return response.data;
  } catch (error) {
    toast.dismiss();
    toast.error(error.message);
  }
};

export const signupApi = async (
  name,
  email,
  password,
  phone,
  gender,
  genderPreference
) => {
  try {
    const bodyData = {
      name,
      email,
      password,
      phone: parseInt(phone),
      gender,
      genderPreference,
    };

    const request = {
      url: signUpEndpoints.url,
      method: signUpEndpoints.method,
      bodyData,
      withCredentials: signUpEndpoints.withCredentials,
    };

    toast.loading("Signing you up");

    const response = await apiConnector(request);

    toast.dismiss();

    if (response.status !== 201) {
      let message = response.data?.message;

      // If backend message is an object
      if (typeof message === "object" && message !== null) {
        message =
          message.message ||
          message.error ||
          "Mobile number already exists";
      }

      // If message is still not a string
      if (typeof message !== "string") {
        message = "Could not register user";
      }

      throw new Error(message);
    }

    toast.success("User registered successfully");

    return true;

  } catch (error) {
    toast.dismiss();

    console.error("Signup error:", error);

    toast.error(
      typeof error?.message === "string"
        ? error.message
        : "Could not register user"
    );

    return false;
  }
};

export const sendOtpApi = async (email) => {
  try {
    const bodyData = {
      email,
    };
    const request = {
      url: sendOtpEndpoint.url,
      method: sendOtpEndpoint.method,
      bodyData,
      withCredentials: sendOtpEndpoint.withCredentials,
    };
    toast.loading("Sending OTP");
    const response = await apiConnector(request);
    toast.dismiss();

    if (response.status !== 200) {
      throw new Error(response.data.message || "Couldn't send OTP");
    }

    return true;
  } catch (error) {
    toast.dismiss();

    console.error("Send OTP error:", error);

    // Pass the actual backend error to SendEmail.tsx
    throw error;
  }
};

export const verifyOtpApi = async (email, otp) => {
  try {
    const bodyData = {
      email,
      otp: parseInt(otp),
    };
    const request = {
      url: verifyOtpEndpoint.url,
      method: verifyOtpEndpoint.method,
      bodyData,
      withCredentials: verifyOtpEndpoint.withCredentials,
    };
    toast.loading("Verifying OTP");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("OTP Verified");
    return response.data.token;
  } catch (error) {
    toast.dismiss();
    toast.error("Couldn't verify OTP");
    return null;
  }
};

export const updatePasswordApi = async (email, token, password) => {
  try {
    const bodyData = { email, token, newPassword: password };
    const request = {
      url: updatePasswordEndpoint.url,
      method: updatePasswordEndpoint.method,
      bodyData,
      withCredentials: updatePasswordEndpoint.withCredentials,
    };
    toast.loading("Updating Password");
    const response = await apiConnector(request);
    if (response.status !== 200)
      throw new Error(response.data.message || "error occuered");
    toast.dismiss();
    toast.success("Password Updated");
    return true;
  } catch (error) {
    toast.dismiss();
    toast.error("Couldn't update password");
    return false;
  }
};

export const getUserProfileApi = async () => {
  try {
    const request = {
      url: getUserProfileEndpoint.url,
      method: getUserProfileEndpoint.method,
      withCredentials: getUserProfileEndpoint.withCredentials,
    };
    const response = await apiConnector(request);
    if (response.status !== 200) {
      throw new Error(response.data?.message || "Failed to fetch user profile");
    }
    return response.data;
  } catch (error) {
    console.error("getUserProfileApi:", error);
    return null;
  }
};

export const updateGenderPreferenceApi = async (genderPreference) => {
  try {
    const bodyData = { genderPreference };
    const request = {
      url: updateGenderPreferenceEndpoint.url,
      method: updateGenderPreferenceEndpoint.method,
      bodyData,
      withCredentials: updateGenderPreferenceEndpoint.withCredentials,
    };
    const response = await apiConnector(request);
    if (response.status !== 200) {
      throw new Error(response.data?.message || "Failed to update preference");
    }
    return response.data;
  } catch (error) {
    console.error("updateGenderPreferenceApi:", error);
    throw error;
  }
};

export const testAuth = async () => {
  const url = "https://carpool-backend-muj.onrender.com/api/auth/test-auth";
};

